var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92577 9.46791C7.35774 5.15597 8.57373 3 10.4993 3C12.425 3 13.641 5.15597 16.0729 9.46791L16.376 10.0052C18.3969 13.5884 19.4074 15.38 18.4941 16.69C17.5809 18 15.3214 18 10.8024 18H10.1963C5.67732 18 3.41783 18 2.50456 16.69C1.5913 15.38 2.60178 13.5884 4.62273 10.0052L4.92577 9.46791Z",
    stroke: "#EBF0F3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.16602V11.3327",
    stroke: "#EBF0F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4993,
    cy: 13.8333,
    rx: 0.833333,
    ry: 0.833333,
    fill: "#EBF0F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/WarningTriangle.cad2b4523971ee7c2b395b1cbd4a1f3e.svg";
export { ForwardRef as ReactComponent };